<template>
  <div class="row">
    <div class="col place">
      PLACE
    </div>
    <div class="col name">
      TEAM
    </div>
    <div class="col score">
      TOTAL
    </div>
    <div class="col score">
      THRU
    </div>
    <div class="mobile-col">
      Leaderboard
    </div>
  </div>
</template>
<script>
export default {
  name: 'ScoreHeader',
};
</script>
<style lang="scss" scoped>
  @mixin mobile {
    @media (max-width: 800px) { @content; }
  }

  .row{
    color: white;
    display: flex;
    background: #12A650;
    font-size: 1.5rem;

    @include mobile{
      font-size: 1rem;
    }
  }

  .place{
    justify-content: center;
    width: 10rem;
  }

  .score{
    justify-content: center;
    width: 8rem;
  }

  .col{
    display: flex;
    align-items: center;
    margin-right: 1rem;

    @include mobile{
      display: none;
    }

    &.name{
      flex: 1;
    }
    &:last-child{
      margin-right: 0;
    }
  }

  .mobile-col{
    display: none;
    @include mobile{
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
      flex: 1;
      font-size: 1.2rem;
      padding: .5rem 0;
    }
  }
</style>
